import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import ChatMessageListUI from './ChatMessageListUI.js'
import ChatMessageList2UI from './ChatMessageList2UI.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class ChatMessageList2SF extends Component {
  constructor(props) {
    super(props)

    this.state = {
      errorList: null,
      replyMode: false,

      selectedUserId: null,
      selectedAccountId: null,
      selectedPhone: null,
      downloadMode: false,
      selectedMesgDate: null,
      // upload
      fileUploadMode: false,
      fileUploadSuccessMsg: null,
      fileUploadErrorList: null,
      fileUploadSubmitted: false,
      //
      statusUpdateMode: false,
      setFollowUpMode: false,
      checked: false,
      checked2: false,

      message: '',
      submitted: false, // Prevents multiple submissions
      userMessageList: [],
    }
    this.chatContainerRef = React.createRef() // Reference to scroll container

  }

  render() {
    return (
      <ChatMessageList2UI
        context={this.props.context}
        account={this.state.account}
        errorList={this.state.errorList}
        userMessageList={this.state.userMessageList}
        draftMessageList={this.state.draftMessageList}
        onRefreshClick={this.onRefreshClick}
        filteredList={this.state.filteredList}
        //
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        //
        checked={this.state.checked}
        onShowStarred={this.onShowStarred}
        // send message
        selectedUserId={this.state.selectedUserId}
        selectedAccountId={this.state.selectedAccountId}
        selectedPhone={this.state.selectedPhone}
        // download
        onDownloadClick={this.onDownloadClick}
        downloadMode={this.state.downloadMode}
        selectedMesgDate={this.state.selectedMesgDate}
        // upload
        fileUploadMode={this.state.fileUploadMode}
        fileUploadSubmitted={this.state.fileUploadSubmitted}
        fileUploadSuccessMsg={this.state.fileUploadSuccessMsg}
        fileUploadErrorList={this.state.fileUploadErrorList}
        onFileUploadClick={() => { this.setState({ fileUploadMode: true }) }}
        onfileUploadCancel={() => { this.setState({ fileUploadMode: false }) }}
        onfileUpload={this.onfileUpload}
        //
        statusUpdateMode={this.state.statusUpdateMode}
        onUpdateStatusClick={this.onUpdateStatusClick}
        onUpdateStatusCancel={() => { (this.setState({ statusUpdateMode: false })) }}
        //
        setFollowUpMode={this.state.setFollowUpMode}
        onSetFollowUpClick={this.onSetFollowUpClick}
        onSetFollowUpCancel={() => { (this.setState({ setFollowUpMode: false })) }}
        //
        chatContainerRef={this.chatContainerRef} // Pass ref to UI

        submitted={this.state.submitted}
        message={this.state.message}
        onMessageChange={(event) => { this.setState({ message: event.target.value }) }}
        onSendMessage={this.onReplyClick}
        filteredUserList={this.props.filteredUserList}
        onUserChange={this.onUserChange}
        //
        checked2={this.state.checked2}
        onShowUnread={this.onShowUnread}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccount(context)
    this.getUser(context)
    this.getDraftMessages(context)
    this.getChatsA(context)
    this.getChatMessages(context)
    this.scrollToBottom()
  }

  componentDidUpdate(prevProps) {
    this.scrollToBottom()
  }

  scrollToBottom = () => {
    if (this.chatContainerRef.current) {
      this.chatContainerRef.current.scrollTop = this.chatContainerRef.current.scrollHeight
    }
  }

  onShowUnread = () => {
    let context = this.props.context
    let newChecked = !this.state.checked2
    this.setState({
      checked2: newChecked
    })
    this.getChatsA(context)
  }

  getAccount(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Account(this.props.match.params.accountId),
      callback: this.getAccountCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountCallback = (response) => {
    this.setState({ account: response.account })
  }

  getUser(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/users/${this.props.match.params.userId}`,
      cacheKey: CacheKeys.User(this.props.match.params.accountId, this.props.match.params.userId),
      callback: this.getUserCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getUserCallback = (response) => {
    this.setState({ user: response.accountUser })
  }

  getDraftMessages(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/users/${this.props.match.params.userId}/chatMessages/statuses/draft`,
      cacheKey: CacheKeys.ChatMessages(this.props.match.params.accountId, this.props.match.params.userId, 'draft'),
      callback: this.getDraftMessagesCallback,
      ttlInSecs: 0
    })
    cacheManager.getObject2(context)
  }

  getDraftMessagesCallback = (response) => {
    let combinedMessage = response.userMessageList[0] && response.userMessageList[0].chatMessageList.map(message => `${message.message}`).join('\n\n')
    this.setState({
      draftMessageList: response.userMessageList,
      message: combinedMessage,
      errorList: response.errorList
    })
  }

  getChatMessages(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/users/${this.props.match.params.userId}/chatMessages`,
      cacheKey: CacheKeys.ChatMessages(this.props.match.params.accountId, this.props.match.params.userId),
      callback: this.getChatMessagesCallback,
      ttlInSecs: 0
    })
    cacheManager.getObject2(context)
  }

  getChatMessagesCallback = (response) => {
    // let latestReceivedMessage = null
    let latestMessage = null

    if (response.userMessageList.length > 0) {
      // latestReceivedMessage = response.userMessageList[0].latestReceivedMessage
      latestMessage = response.userMessageList[0].latestMessage
    }
    this.setState({
      userMessageList: response.userMessageList,
      errorList: response.errorList,
      latestMessage,
      // latestReceivedMessage,
    })
  }

  getChatsA(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/chatMessages/statuses/recent/unread/draft`,
      cacheKey: CacheKeys.Chats(),
      callback: this.getChatsACallback,
      ttlInSecs: 0
    })
    cacheManager.getObject2(context)
  }

  getChatsACallback = (response) => {
    let accountList = response.accountMessageList.map((account) => {
      return {
        accountId: account.accountId, accountName: account.accountName,
        latestMessage: account.latestMessage, noOfUnreadMessages: account.noOfUnreadMessages,
        latestDraftMessage: account.latestDraftMessage
      }
    })

    let unreadList = accountList.filter(account => account.noOfUnreadMessages > 0)

    let filtersStr = sessionStorage.getItem(CacheKeys.AccountUsersFilter(this.props.match.params.accountId, this.props.match.params.userId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.applyFilters(this.state.checked2 ? unreadList : accountList, filters.searchFilter ? filters.searchFilter : '', response.errorList)
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.state.accountList, searchFilter)
  }

  applyFilters(accountList, searchFilter, errorList) {
    let filteredList = accountList
    if (searchFilter) {
      searchFilter = searchFilter.toLocaleLowerCase()
      filteredList = filteredList.filter(acc =>
        acc.accountName.toLocaleLowerCase().includes(searchFilter) ||
        (acc.userName && acc.userName.toLocaleLowerCase().includes(searchFilter))
      )
    }

    this.setState({
      accountList: accountList,
      filteredList: filteredList,
      searchFilter: searchFilter,
      errorList: errorList
    })

    let filters = { searchFilter: searchFilter }
    sessionStorage.setItem(CacheKeys.AccountUsersFilter(this.props.match.params.accountId, this.props.match.params.userId), JSON.stringify(filters))
  }

  onShowStarred = () => {
    let newChecked = !this.state.checked
    CacheManager.setObject(CacheKeys.AccountRepaymentsChecked(), { checked: newChecked })
    this.setState({
      checked: newChecked
    })
  }

  onReplyClick = () => {
    let context = this.props.context
    this.setState({ submitted: true })
    if (this.props.account.accountId) {
      RestApiUtils.post(this.props.context,
        `/api/su/accounts/${this.props.account.accountId}/users/${this.props.user.userId}/chatMessages`,
        this.onSubmitCallback, {
        message: this.state.message,
      }
      )
    }

    if (!this.props.account.accountId) {
      RestApiUtils.post(this.props.context,
        `/api/su/phoneNumber/${this.props.latestReceivedMessage.phoneNumber}/chatMessages`,
        this.onSubmitCallback, {
        message: this.state.message,
      }
      )
    }
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  onDownloadClick = (event) => {
    let accountId = event.currentTarget.getAttribute('data-acc-id')
    let rowId = event.currentTarget.getAttribute('data-row-id')
    let parts = rowId.split(':', 3)
    this.setState({ downloadMode: true, selectedMesgDate: parts[0] })

    if (!accountId.startsWith('+')) {
      RestApiUtils.get(this.props.context,
        `/api/su/accounts/${accountId}/files/${parts[1]}/fileName/${parts[2]}/fileDownloadSignedUrl`,
        this.onDownloadClickCallback, null, null
      )
    }

    if (accountId.startsWith('+')) {
      RestApiUtils.get(this.props.context,
        `/api/su/phoneNumber/${accountId}/files/${parts[1]}/fileName/${parts[2]}/fileDownloadSignedUrl`,
        this.onDownloadClickCallback, null, null
      )
    }
  }

  onDownloadClickCallback = (response) => {
    this.setState({ downloadMode: false, errorList: response.errorList })
    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onUpdateStatusClick = (event) => {
    let accountId = event.currentTarget.getAttribute('data-acc-id')
    let messageDate = event.currentTarget.getAttribute('data-date')
    let phone = event.currentTarget.getAttribute('data-phone')
    this.setState({ statusUpdateMode: true, selectedAccountId: accountId, selectedMesgDate: messageDate, selectedPhone: phone })
  }

  onSetFollowUpClick = (event) => {
    let accountId = event.currentTarget.getAttribute('data-acc-id')
    let messageDate = event.currentTarget.getAttribute('data-date')
    let phone = event.currentTarget.getAttribute('data-phone')
    this.setState({ setFollowUpMode: true, selectedAccountId: accountId, selectedMesgDate: messageDate, selectedPhone: phone })
  }

  onfileUpload = (fileId, fileName, fileType, fileSize) => {
    this.setState({
      fileUploadSubmitted: true,
      fileUploadSuccessMsg: null,
      fileUploadErrorList: []
    })
    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/users/${this.props.user.userId}/chatMessages/files/validation`,
      this.onfileUploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      }
    }
    )
  }

  onfileUploadCallback = (response) => {
    this.setState({ fileUploadSubmitted: false })
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      fileUploadSuccessMsg: response.success,
      fileUploadErrorList: errorList,
    })

    this.props.onRefreshClick('noBusy')

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          fileUploadSuccessMsg: null
        })
      }, 2000)
    }
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Chats())
    CacheManager.removeObject(CacheKeys.ChatMessages(this.props.match.params.accountId, this.props.match.params.userId))
    CacheManager.removeObject(CacheKeys.ChatMessages(this.props.match.params.accountId, this.props.match.params.userId, 'draft'))

    this.setState({
      errorList: null,
      userMessageList: null,
      draftMessageList: null,
      latestReceivedMessage: null,
      latestMessage: null,
    }, () => {
      this.getChatMessages(context)
      this.getChatsA(context)
      this.getDraftMessages(context)
    })
  }
}

export default withRouter(ChatMessageList2SF)
